'use client'

import React from 'react'

import * as TooltipPrimitive from '@radix-ui/react-tooltip'
import { twMerge } from 'tailwind-merge'

const TooltipProvider = TooltipPrimitive.Provider

const Tooltip = TooltipPrimitive.Root

const TooltipTrigger = TooltipPrimitive.Trigger

const TooltipPortal = TooltipPrimitive.Portal

export type TooltipProps = React.ComponentPropsWithoutRef<
  typeof TooltipPrimitive.Root
>

export type TooltipTriggerProps = React.ComponentPropsWithoutRef<
  typeof TooltipPrimitive.Trigger
>

export interface TooltipContentProps extends React.ComponentPropsWithoutRef<
  typeof TooltipPrimitive.Content
> {
  inverseColors?: boolean
  noProvider?: boolean
}

const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  TooltipContentProps
>(
  (
    {
      className,
      side = 'top',
      sideOffset = 5,
      inverseColors = false,
      noProvider = false,
      ...props
    },
    ref,
  ) => {
    const content = (
      <TooltipPortal>
        <TooltipPrimitive.Content
          ref={ref}
          side={side}
          sideOffset={sideOffset}
          className={twMerge(
            'z-50 overflow-hidden rounded-md border  px-3 py-1 text-sm shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
            inverseColors
              ? 'bg-white america:bg-white dark:bg-default-dark border border-primary-300 dark:border-primary-700 text-primary-900 dark:text-primary-100'
              : 'bg-primary-800 america:bg-primary-900 dark:bg-primary-100 border-primary-700 dark:border-primary-300 text-primary-100 america:text-white dark:text-primary-900',
            className,
          )}
          {...props}
        />
      </TooltipPortal>
    )
    if (noProvider) {
      return content
    }
    return <TooltipProvider>{content}</TooltipProvider>
  },
)
TooltipContent.displayName = TooltipPrimitive.Content.displayName

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider }
